import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAnimate]'
})
export class AnimateNameDirective implements OnInit {
  @Input() public appAnimate: string = '';
  @Input() public delay: number = 0;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    // Set initial opacity to 0 for fade effects
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
  }

  ngOnInit() {
    if (!this.el?.nativeElement || !this.appAnimate) {
      return;
    }

    // Get delay from attribute if not provided as input
    if (!this.delay) {
      const delayAttr = this.el.nativeElement.getAttribute('delay');
      this.delay = delayAttr ? parseInt(delayAttr, 10) : 0;
    }

    // Apply animation with or without delay
    if (this.delay > 0) {
      this.renderWithDelay();
    } else {
      this.render();
    }
  }

  private render() {
    // Reset opacity for visibility
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    
    // Add animation classes
    this.renderer.addClass(this.el.nativeElement, 'animate__animated');
    this.renderer.addClass(this.el.nativeElement, `animate__${this.appAnimate}`);
    
    // Ensure element is visible during animation
    this.renderer.setStyle(this.el.nativeElement, 'visibility', 'visible');
  }

  private renderWithDelay() {
    setTimeout(() => {
      this.render();
    }, this.delay);
  }
}
